module.exports = __webpack_public_path__ + "static/media/cloud4.85744a30.svg";